<template>

  <div id="app">

      <el-main>
        <div class="college_main college_souye_element_ui">
          <div class="main_top">
            <el-row>
              <el-col class="top_fenlei" :xs="24" :sm="7" :md="5" :lg="5">
                <div class="fenlei_xuanxiang" v-for="(item,index) in daohang" v-bind:key="index">
                  <a :href="item.link">
                    <div class="text_bt bt_neirong">{{item.name}}</div>
                  </a>
                  <span class="text_nr nr_neirong" v-for="(site,ind) in item.child" v-bind:key="ind">
                    <a :href="site.link">{{site.name}}</a>
                  </span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="17" :md="19" :lg="14">
                <div class="top_lunbo">
                  <el-carousel height="415px">
                    <el-carousel-item v-for="(v,index) in banner" v-bind:key="index">
                      <!--                    <h3 class="small">{{ item }}</h3>-->
                      <img style="width: 100%" :src="v.img"/>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </el-col>
              <el-col :xs="24" :sm="5" :md="5" :lg="5" style="padding-left: 0; padding-right: 0;" class="hidden-md-and-down">
                <div class="top_xinxi">
                  <div class="xinxi_kuang">
                    <img class="kuang_img" src="../../../assets/home/college/defauthead.png"/>
                    <div class="kuang_butt" v-if="data_name==''"><span class="butt_text">立即登录</span></div>
                    <div class="kuang_butt" v-if="data_name!==''">
                      <span class="butt_text">
                        <a href="/user.html#/login"
                           style="color: #FFFFFF">个人中心</a></span></div>
                    <div class="kuang_text" v-if="data_name==''">立即登录获取你的推荐课程</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="ditu_bt">
          <span class="bt_text"><a href="http://view.officeapps.live.com/op/view.aspx?src=http://api.yi-mix.com/storage/attachment/user/2021/04/06/e0a6cebb1671fc1b46e93454501d0de2.docx">学习地图</a>
</span>
          <span class="bt_texts">核心场景学习、官方精选、让学习更简单！</span>
        </div>
        <div class="ditu">
          <el-row :gutter="20">
            <el-col :xs="12" :sm="8" :md="6" :lg="4" v-for="(site,index) in xuexiditu" v-bind:key="index" style="margin-top: 5px">
              <a :href="'/college.html'+site.link">
              <div class="ditu_img" :style="'background:url(' + site.img + ') ;'">
                <div class="img_text">全部课程</div>
                <div class="img_texts">实力快速进阶</div>
              </div>
              </a>
            </el-col>
          </el-row>
        </div>
<!--        <div class="ditu_bt">-->
<!--          <span class="bt_text">新手指导</span>-->
<!--          <span class="bt_texts">新手开店到进阶提升、系统化教程、店铺生意更简单</span>-->
<!--        </div>-->
<!--        <div class="zhinan">-->
<!--          <el-row :gutter="20">-->
<!--            <el-col :xs="12" :sm="8" :md="6" :lg="6" :xl="6"  v-for="(item,index) in tuijian" v-bind:key="index">-->
<!--              <div class="zhinan_img">-->
<!--                <div class="img_flot">-->
<!--                  <div class="img_biaoqian">-->
<!--                    <span class="biaoqian_text">新手指南</span>-->
<!--                  </div>-->
<!--                  <a :href="'#/article/'+ item.article_type + '/' + item.article_id">-->
<!--                  <div class="flot_biaoti">-->
<!--&lt;!&ndash;                    {{item.article.title.slice(0,15)}}&ndash;&gt;-->
<!--                  </div>-->
<!--                  </a>-->
<!--                  <div class="flot_shijian">发布时间：{{item.created_at.slice(0,10)}}</div>-->
<!--                  <div class="flot_img">-->
<!--                    <img src="../../../assets/home/college/TB1OaTWRXzqK1RjSZFoXXbfcXXa-100-100.png"/>-->
<!--                  </div>-->
<!--                  <div class="flot_lamu">-->
<!--                    栏目：{{item.article_type_text}}-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </div>-->
        <div style="width: 100%;height: 100px">
        </div>
      </el-main>
<!--      <el-footer height="320px">-->
<!--        <div class="college_footer">-->
<!--          <div class="footer_lanmu_one text">© 2019-2020 仪海仪家 版权所有</div>-->
<!--          <div class="footer_lanmu_two text">-->
<!--            <span class="two_text">著作权与商标声明</span>-->
<!--            <span class="two_text">平台规则</span>-->
<!--            <span class="two_text">服务条款</span>-->
<!--            <span class="two_text">帮助中心</span>-->
<!--            <span class="two_text">关于仪海仪家</span>-->
<!--            <span class="two_text">联系我们</span>-->
<!--            <span class="two_text two_text2">网站导航</span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </el-footer>-->
<!--    </el-container>-->
  </div>
</template>
<script>

export default {
  // inject:['reload'],
  name: "index",

  data: function () {

    return {
      data_name: '',
      banner: [],
      xuexiditu: [],
      tuijian: [],
      daohang: [],
      daohangzixiang:[],
      swiperOption: {
        autoplay: 3000,
        pagination: '.swiper-pagination',
        autoplayDisableOnInteraction: false,
        loop: true

      },
      swipers: [{fdcImage: 'http://api.yi-mix.com/storage/yxx_banner/rLqKcMAXG96aNnO8DDtDGYVty3ut44BF5uJrCChw.png'}, {fdcImage: 'http://yi-mix.com/attachment/sys/2b663bb8ab2a478c8509dee4780140b3.jpg'}]
    }
  },

  components: {

  },

  methods: {

    init: function () {
      // var t = this
      this.lanmu();
      this.lunbo();
      this.tuijianwei();
      this.shouyedaohang();
      this.denglu();

    },

    denglu() {
      var t = this
      var id = localStorage.getItem("uid")
      if (id == null) {
        return
      }
      var url = window.config.api_url + '/user/info?token=' + id
      t.axios
          .get(url)
          .then(function (res) {
            // console.log(res)
            t.data_name = res.data.name
          })
    },
    lunbo: function () {
      var that = this
      this.axios
          .get(window.config.api_url + '/college/banner')
          .then(function (res) {
            that.banner = res.data
            console.log(that.banner)
          });

    },
    lanmu: function () {
      var that = this
      this.axios
          .get(window.config.api_url + '/college/lanmu')
          .then(function (res) {
            that.xuexiditu = res.data
            console.log(that.xuexiditu)
          });
    },
    tuijianwei: function () {
      var that = this
      this.axios
          .get(window.config.api_url + '/college/tuijian/home')
          .then(function (res) {
            that.tuijian = res.data
            console.log(that.tuijian)
          });
    },

    shouyedaohang: function () {
      var that = this
      this.axios
          .get(window.config.api_url + '/college/nav')
          .then(function (res) {
            that.daohang = res.data
            console.log(that.daohang)
          });
    },

  },

  mounted() {
    setTimeout(() => {
      this.asyncCount = 5
    }, 1000)
    /**
     * iframe-宽高自适应显示
     */
    function changeMobsfIframe(){
      const mobsf = document.getElementById('mobsf');
      const deviceWidth = document.body.clientWidth;
      const deviceHeight = document.body.clientHeight;
      mobsf.style.width = (Number(deviceWidth)-1000) + 'px'; //数字是页面布局宽度差值
      mobsf.style.height = (Number(deviceHeight)-1000) + 'px'; //数字是页面布局高度差
    }

    changeMobsfIframe()

    window.onresize = function(){
      changeMobsfIframe()
    }

  },

  created: function () {

    this.init();
  },
  // watch: {
  //   $route () {
  //     /**
  //      * 跳转到本页面需要执行的操作
  //      * to do……
  //      */
  //     window.location.reload()
  //
  //   }
  // },
}
</script>
<style>
/*.college_page_important_qiangzhi_buxudong .el-input__inner {*/
/*  position: absolute;*/
/*  width: 503px !important;*/
/*  height: 45px !important;*/
/*  border: 2px solid #C6241D !important;*/
/*  border-radius: 5px 0px 0px 5px !important;*/
/*  padding: 0 35px !important;*/
/*}*/
</style>
<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

@head_text: Source Han Sans CN;
@font-face {
  //https://cdn.repository.webfont.com/webfonts/nomal/144669/46865/6098f296f629d8742012425b.css
}

//@import "../../../assets/css/home";
@import "../../../assets/css/home_college";
.hallo {
  font-family: Source Han Sans CN;
}
</style>
<style lang="less" scoped>
@font-face {

}

.college_main {
  background-color: #F4F4F4;
  height: 445px;

  .main_top {
    width: 80%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    height: 420px;

    .top_lunbo {
      width: 98%;
      height: 98%;
      margin-left: 1%;
      margin-top: 1%;
    }

    .top_xinxi {
      height: 420px;
      width: 100%;
      float: left;

      .xinxi_kuang {
        height: 97%;
        margin-top: 3%;
        background: #FFFFFF;
        //display:table-cell;
        text-align: center;

        .kuang_img {
          width: 95px;
          height: 95px;
          margin-top: 55px;
          margin-bottom: 40px;
        }

        .kuang_butt {
          text-align: center;
          width: 160px;
          height: 40px;
          background: #C6241D;
          margin: 0 auto;
          border-radius: 5px;

          .butt_text {
            line-height: 40px;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
          }
        }

        .kuang_text {
          text-align: center;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          line-height: 100px;
        }
      }
    }

    .top_fenlei {
      background: #FFFFFF;
      height: 420px;

      .fenlei_xuanxiang {
        width: 100%;
        height: 104px;
        float: left;

        .bt_neirong {
          margin-top: 15px;
          margin-left: 18px;
        }

        .nr_neirong {
          float: left;
          margin-top: 10px;
          margin-left: 18px;
          padding-right: 10px;
          border-right: 1px solid;
        }

        .text_bt {
          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }

        .text_nr {
          font-size: 10px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
}

.ditu_bt {
  width: 80%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;

  .bt_text {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    line-height: 80px;
    margin-right: 12px;
  }

  .bt_texts {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #777777;
    line-height: 80px;
  }
}

.ditu {
  width: 80%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;

  .ditu_img {
    //float: left;
    height: 190px;
    text-align: center;
    background-image: url("../../../assets/home/college/cT3mZ1MYQ680qLrOXCUFF9qDXioLVowouBJdOvFj.png");

    .img_text {
      padding-top: 120px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #FFFFFF;
    }

    .img_texts {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
      //line-height: 100px;
    }
  }
}

.zhinan {
  width: 80%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;

  .zhinan_img {
    height: 236px;
    background-image: url("../../../assets/home/college/TB1LiNiObrpK1RjSZTEXXcWAVXa-285-290.png");

    .img_biaoqian {
      float: left;
      margin-top: 28px;
      width: 68px;
      height: 20px;
      background: #C6241D;
      border-radius: 3px;
      text-align: center;

      .biaoqian_text {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
      }
    }

    .img_flot {
      width: 88%;
      margin-left: 6%;

      .flot_biaoti {
        width: 100%;
        float: left;
        margin-top: 20px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        //line-height: 100px;
      }

      .flot_shijian {
        float: left;
        margin-top: 20px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }

      .flot_img {
        width: 100%;
        float: left;
        margin-top: 15px;
      }

      .flot_lamu {
        float: left;
        margin-top: 15px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        //line-height: 100px;
        width: 100%;
      }
    }
  }
}



.el-footer {
  background: #333333;
}

.college_footer {
  width: 80%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  //height: 320px;
  .footer_lanmu_one {
    margin-top: 129px;
  }

  .footer_lanmu_two {
    margin-top: 34px;

    .two_text {
      padding-right: 8px;
      padding-left: 8px;
      border-right: 1px solid #FFFFFF;
    }

    .two_text2 {
      border-right: none;
    }
  }

  .text {
    text-align: center;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
  }

}

.el-main {
  padding: 0;
}
</style>
<style lang="less">
.college_souye_element_ui{
.el-carousel__arrow {
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 0;
  width: 0;
  cursor: none;
  transition: .3s;
  border-radius: 0;
  background-color: rgba(31,45,61,.11);
  color: #FFF;
  position: absolute;
  top: 0;
  z-index: 0;
  transform: translateY(-50%);
  text-align: center;
  font-size: 12px;
}
}
</style>